var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal",
      attrs: {
        name: "EmailHistoriesManagementModal",
        width: "75%",
        height: "auto",
        scrollable: true,
        pivotX: 1.0,
        minWidth: 900,
        minHeight: 900,
        clickToClose: true
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "email-histories-page" }, [
        _c("div", { staticClass: "hisories-page-header margin-side" }, [
          _c("div", { staticClass: "btn-back-wrapper" }, [
            _c("div", {
              staticClass: "btn-back icon-back",
              on: { click: _vm.cancelClick }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-title h2-text" }, [
            _vm._v("Email History")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab-wrapper" }, [
            _c(
              "a",
              {
                staticClass: "tab-name",
                class: { active: !_vm.isParticipantTab },
                attrs: { href: "javascript: void(0);" },
                on: {
                  click: function($event) {
                    _vm.handleChangeTableClick(false)
                  }
                }
              },
              [_c("span", { staticClass: "text" }, [_vm._v("On Site Contact")])]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "tab-name",
                class: { active: _vm.isParticipantTab },
                attrs: { href: "javascript: void(0);" },
                on: {
                  click: function($event) {
                    _vm.handleChangeTableClick(true)
                  }
                }
              },
              [_c("span", { staticClass: "text" }, [_vm._v("Participant")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "histories-page-body" }, [
          _c("div", { staticClass: "ems-table margin-side" }, [
            _vm.isParticipantTab
              ? _c("div", { staticClass: "participant-table-container" }, [
                  _c(
                    "div",
                    { staticClass: "search-section ems-input-wrapper" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.keyword,
                            expression: "keyword"
                          }
                        ],
                        staticClass: "input",
                        attrs: { placeholder: "Search for emails" },
                        domProps: { value: _vm.keyword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.keyword = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-participant-container" }, [
                    _c("div", { staticClass: "table-header" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _vm._l(_vm.participantColsHeader, function(
                            col,
                            index
                          ) {
                            return [
                              _c("HeaderColumnEMS", {
                                class: col.className,
                                attrs: {
                                  headerObject: col,
                                  showResizeLine:
                                    index + 1 !=
                                    _vm.participantColsHeader.length,
                                  showIcon:
                                    index + 1 !=
                                    _vm.participantColsHeader.length,
                                  sortObject: _vm.sortObject,
                                  styleObject: {
                                    width: _vm.columnWidth.emailTemplate.size
                                      ? _vm.columnWidth.emailTemplate.size +
                                        "px"
                                      : _vm.participantColsHeader.width
                                  }
                                },
                                on: { CHANGE_SORT_OPTION: _vm.handleSortChange }
                              })
                            ]
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ems-table-body" },
                      [
                        _vm._l(_vm.histories, function(h) {
                          return _c("div", { staticClass: "ems-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("dateFormatMMDDYY")(h.time))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm._f("templateName")(h.template))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [_vm._v(_vm._s(h.firstName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [_vm._v(_vm._s(h.lastName))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "field-value value-text",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [_vm._v(_vm._s(h.recipients))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "field-value value-text resend-btn-wrapper",
                                style: {
                                  width: _vm.columnWidth.emailTemplate.size
                                    ? _vm.columnWidth.emailTemplate.size + "px"
                                    : "16.67%"
                                }
                              },
                              [
                                h.template != "CANCELLATION"
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "ap-btn secondary resend-btn",
                                        on: {
                                          click: function($event) {
                                            _vm.handleResendEmail(h)
                                          }
                                        }
                                      },
                                      [_vm._v("Resend")]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        }),
                        _vm._v(" "),
                        _c(
                          "infinite-loading",
                          {
                            attrs: { distance: 100 },
                            on: { infinite: _vm.infiniteHandler }
                          },
                          [
                            _c("Spinner", {
                              attrs: { slot: "spinner" },
                              slot: "spinner"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-more" },
                              slot: "no-more"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-results" },
                              slot: "no-results"
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ])
                ])
              : _c(
                  "div",
                  { staticClass: "histories-table-container" },
                  [
                    _c("EmailHistoriesHeader"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ems-table-body",
                        attrs: { id: "ems-table-body" }
                      },
                      [
                        _vm._l(_vm.histories, function(h) {
                          return _c(
                            "div",
                            { key: h.id, staticClass: "ems-row" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "field-value value-text padding-left-40px",
                                  style: {
                                    width: _vm.columnWidth.sentDate.size
                                      ? _vm.columnWidth.sentDate.size + "px"
                                      : "13%"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("dateFormatMMDDYY")(h.time))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.emailTemplate.size
                                      ? _vm.columnWidth.emailTemplate.size +
                                        "px"
                                      : "17%"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm._f("templateName")(h.template))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.relatedEvent.size
                                      ? _vm.columnWidth.relatedEvent.size + "px"
                                      : "28%"
                                  }
                                },
                                [_vm._v(_vm._s(h.relatedEvents.join(", ")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.recipients.size
                                      ? _vm.columnWidth.recipients.size + "px"
                                      : "28%"
                                  }
                                },
                                [_vm._v(_vm._s(h.recipients))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "field-value value-text",
                                  style: {
                                    width: _vm.columnWidth.actions.size
                                      ? _vm.columnWidth.actions.size + "px"
                                      : "14%",
                                    "text-align": "right"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "action-text",
                                      on: {
                                        click: function($event) {
                                          _vm.goToEventDetails(h.id)
                                        }
                                      }
                                    },
                                    [_vm._v("View Details")]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "infinite-loading",
                          {
                            attrs: { distance: 100 },
                            on: { infinite: _vm.infiniteHandler }
                          },
                          [
                            _c("Spinner", {
                              attrs: { slot: "spinner" },
                              slot: "spinner"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-more" },
                              slot: "no-more"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "infinite-status-prompt",
                              attrs: { slot: "no-results" },
                              slot: "no-results"
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-478c16ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478c16ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/email/EmailHistoriesManagement.vue
// module id = 1697
// module chunks = 1